import config from "./settings";
import errorService from "./error.service";
import moment from "moment";
import { commonDelete, commonGet, commonGetBlob } from "./common";

class CommunicationMessages {
  static async getPage(token, providerId, userId, page, pageSize, filters) {
    const query = new URLSearchParams({
      includePrivate: "true",
      pageSize: String(pageSize),
      from: String((page - 1) * pageSize),
    });
    if (filters.type) query.set("communicationMessageType", filters.type);
    if (filters.from) {
      query.set("dateFrom", String(moment(filters.from).startOf("day").valueOf()));
    }
    if (filters.to) {
      // The API truncates timestamps to seconds and uses an exclusive upper bound.
      // Next local midnight includes the final second of the selected day (also on DST days).
      query.set("dateTo", String(moment(filters.to).startOf("day").add(1, "day").valueOf()));
    }
    const url = `${config.url}/auth/providers/${providerId}/serviceusers/${userId}/communicationmessages?${query}`;
    try {
      const result = await fetch(url, {
        method: "GET",
        headers: { ...config.configHeaders, Authorization: "Bearer " + token },
      });
      const response = await errorService.handleErrors(result);
      const count = result.headers.get("X-Total-Count");
      const total = Number(count);
      if (!Array.isArray(response)) throw new Error("Unable to load notes.");
      if (count === null || !/^\d+$/.test(count) || !Number.isSafeInteger(total)) {
        throw new Error("The response is missing a valid total message count.");
      }
      return { response, total };
    } catch (error) {
      return { error };
    }
  }

  // Only the per-user latest endpoint delegates to the paginated list handler.
  // Preserve its existing includePrivate default by leaving that parameter absent.
  static async getLatestPage(token, providerId, userId, pageSize, from, onlyAlerts) {
    const query = new URLSearchParams({ pageSize: String(pageSize), from: String(from) });
    if (onlyAlerts) query.set("communicationMessageType", "alert");
    const url = `${config.url}/auth/providers/${providerId}/serviceusers/${userId}/latestcommunicationmessages?${query}`;
    try {
      const result = await fetch(url, {
        method: "GET",
        headers: { ...config.configHeaders, Authorization: "Bearer " + token },
      });
      const response = await errorService.handleErrors(result);
      const count = result.headers.get("X-Total-Count");
      const total = Number(count);
      if (!Array.isArray(response)) throw new Error("Unable to load notes.");
      if (count === null || !/^\d+$/.test(count) || !Number.isSafeInteger(total)) {
        throw new Error("The response is missing a valid total message count.");
      }
      return { response, total };
    } catch (error) {
      return { error };
    }
  }

  static downloadCsv(token, providerId, userId, data) {
    const { messageType, dateFrom, dateTo } = data;
    const qs =
      `communicationMessageType=${messageType || ""}` +
      `&dateFrom=${dateFrom || ""}` +
      `&dateTo=${dateTo || ""}` +
      `&includePrivate=true`;

    const url = `${config.url}/auth/providers/${providerId}/serviceusers/${userId}/communicationmessages/csv?${qs}`;
    // console.log(url);
    return commonGetBlob(token, url);
  }

  static deleteCommunicationMessage(token, providerId, userId, messageId) {
    const url = `${config.url}/auth/providers/${providerId}/serviceusers/${userId}/communicationmessages/${messageId}`;
    return commonDelete(token, url);
  }

  static getLatestCommunicationMessages(
    token,
    providerId,
    userId,
    onlyAlerts = false
  ) {
    const su = !userId ? "" : `serviceusers/${userId}/`;
    const url = `${
      config.url
    }/auth/providers/${providerId}/${su}latestcommunicationmessages${
      onlyAlerts ? "?communicationMessageType=alert" : ""
    }`;

    return commonGet(token, url);
  }
}

export default CommunicationMessages;
